import { render, staticRenderFns } from "./Area2.vue?vue&type=template&id=8935301a&scoped=true"
import script from "./Area2.vue?vue&type=script&lang=js"
export * from "./Area2.vue?vue&type=script&lang=js"
import style0 from "./Area2.vue?vue&type=style&index=0&id=8935301a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8935301a",
  null
  
)

export default component.exports